import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbTypeahead } from "@ng-bootstrap/ng-bootstrap";
import { Observable, of } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { BusyService } from "~app/common/components/busy/busy.service";
import { AnvandareDTO } from "~app/common/models/anvandare/AnvandareDTO";
import { TypeAheadDTO } from "~app/common/models/common/TypeAheadDTO";
import { BusyDirective } from "../../../../../../common/directives/busy/busy.directive";
import { LeverantorService } from "../../leverantor.service";

@Component({
    selector: "rask-redigera-ansvarig-virkeskopare",
    styleUrls: ["./redigera-ansvarig-virkeskopare.component.scss"],
    templateUrl: "./redigera-ansvarig-virkeskopare.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        NgbTypeahead,
        BusyDirective
    ]
})
export class RedigeraAnsvarigVirkeskopareComponent implements OnInit {
    anvandaredto: AnvandareDTO;
    @Input() count = 0;
    @Output() countChange = new EventEmitter<number>();
    @Input() disabled: boolean;
    searchVirkeskopareText: any;
    @Input() virkeskopare: AnvandareDTO;
    @Output() virkeskopareChange = new EventEmitter<AnvandareDTO>();

    private readonly busyService = inject(BusyService);
    private readonly leverantorService = inject(LeverantorService);

    canDelete() {
        return this.virkeskopare != null && !this.disabled;
    }

    delete() {
        this.searchVirkeskopareText = "";
        this.virkeskopareChange.emit(null);
    }

    fromAnvandareDTO(model: AnvandareDTO): string {
        return `${model.fornamn} ${model.efternamn}`;
    }

    fromTypeAheadDTO(model: TypeAheadDTO): string {
        return `${model.namn}`;
    }

    inputVirkeskopareFormat(value: any) {
        return value.efternamn !== undefined ? `${value.fornamn} ${value.efternamn}` : value;
    }

    ngOnInit() {
        this.searchVirkeskopareText = this.virkeskopare ? this.fromAnvandareDTO(this.virkeskopare) : "";
    }

    onSelectVirkeskopare(event) {
        const anvandare = {
            fornamn: event.item.namn,
            efternamn: "",
            id: event.item.id
        } as AnvandareDTO;
        this.searchVirkeskopareText = this.fromTypeAheadDTO(event.item);
        this.virkeskopareChange.emit(anvandare);
        event.preventDefault();
    }

    resultVirkeskopareFormat(value: TypeAheadDTO) {
        return value.namn;
    }

    searchVirkeskopare = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(term => this.searchAnvandare(term))
        );

    private searchAnvandare(term: string): Observable<TypeAheadDTO[]> {
        return term.length > 2 ? this.busyService.addWork(this.leverantorService.searchAnvandare(term), "searchingAnvandare") : of([]);
    }
}
